(() => {
  const lifecycle = new AbortController();
  const { signal } = lifecycle;
  const initialise = () => {
    const labels = document.querySelector('[data-twc-article-carousel-labels]');
    if (!labels) return;

    document.querySelectorAll('[data-twc-article-carousel]:not([data-twc-carousel-ready])').forEach((carousel) => {
      const track = carousel.querySelector('.twc-article-carousel__track');
      const slides = Array.from(carousel.querySelectorAll('.twc-article-carousel__slide'));
      if (!track || slides.length < 2) return;

      carousel.dataset.twcCarouselReady = 'true';
      const controls = document.createElement('div');
      controls.className = 'twc-article-carousel__controls';
      const previous = document.createElement('button');
      const next = document.createElement('button');
      const status = document.createElement('span');
      previous.type = next.type = 'button';
      previous.className = next.className = 'twc-article-carousel__button';
      previous.setAttribute('aria-label', labels.dataset.carouselPrevious);
      next.setAttribute('aria-label', labels.dataset.carouselNext);
      previous.textContent = '←';
      next.textContent = '→';
      status.className = 'twc-article-carousel__status';
      status.setAttribute('aria-live', 'polite');
      controls.append(previous, status, next);
      carousel.append(controls);

      const statusText = (index) => labels.dataset.carouselStatus
        .replace('__INDEX__', String(index + 1))
        .replace('__LENGTH__', String(slides.length));
      const setCurrent = (index) => {
        const current = Math.max(0, Math.min(index, slides.length - 1));
        status.textContent = statusText(current);
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', statusText(slideIndex));
        });
      };
      const currentIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const move = (delta) => {
        const target = Math.max(0, Math.min(currentIndex() + delta, slides.length - 1));
        track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
        setCurrent(target);
      };
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => setCurrent(currentIndex()));
      }, { passive: true, signal });
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      setCurrent(0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true, signal });
  } else {
    initialise();
  }
  window.addEventListener('pagehide', () => lifecycle.abort(), { once: true, signal });
})();
